import { render, staticRenderFns } from "./GlobalChangesWeight.vue?vue&type=template&id=6eb2990f"
import script from "./GlobalChangesWeight.vue?vue&type=script&lang=js"
export * from "./GlobalChangesWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports